import { motion } from 'framer-motion';
import { MessageSquare, Workflow, FlaskConical, Server, Smartphone, Network } from 'lucide-react';

const modules = [
  { icon: MessageSquare, label: 'Chat', detail: 'Conversational entry point', color: '#074EDC' },
  { icon: Workflow, label: 'Create', detail: 'AI-assisted work delivery', color: '#FF8C00' },
  { icon: FlaskConical, label: 'Research', detail: 'Analysis workflows', color: '#4AAC00' },
  { icon: Server, label: 'Host', detail: 'Publish and operate', color: '#ED0216' },
  { icon: Smartphone, label: 'Oversight', detail: 'Mobile approval', color: '#074EDC' },
  { icon: Network, label: 'Connect', detail: 'Governed integration', color: '#FF8C00' },
];

/**
 * The product ecosystem as a clean, governed platform: a unifying core layer
 * with product modules resting on top of it. Legible, professional, no overlap.
 */
export function EcosystemOrbit() {
  return (
    <div className="mx-auto w-full max-w-md">
      {/* product modules */}
      <div className="grid grid-cols-3 gap-2">
        {modules.map(({ icon: Icon, label, detail, color }, i) => (
          <motion.div
            key={label}
            initial={{ opacity: 0, y: 14 }}
            whileInView={{ opacity: 1, y: 0 }}
            whileHover={{ y: -3 }}
            viewport={{ once: true }}
            transition={{ delay: i * 0.05, duration: 0.4 }}
            className="rounded-xl border border-white/12 bg-white/8 p-2.5 backdrop-blur-sm transition-colors hover:bg-white/14 hover:border-white/25"
          >
            <span className="mb-1.5 inline-flex rounded-lg p-1.5" style={{ backgroundColor: `${color}1a` }}>
              <Icon className="h-4 w-4" style={{ color }} />
            </span>
            <div className="text-white/90 text-sm">{label}</div>
            <div className="text-white/55 text-xs">{detail}</div>
          </motion.div>
        ))}
      </div>

      {/* connecting seam */}
      <div className="relative my-2 flex justify-center">
        <span className="h-4 w-px bg-gradient-to-b from-[#074EDC]/40 to-[#074EDC]/10" />
      </div>

      {/* governed core layer */}
      <div className="relative overflow-hidden rounded-2xl border border-[#074EDC]/30 bg-gradient-to-r from-[#074EDC]/10 to-[#FF8C00]/10 px-5 py-3 text-center backdrop-blur-sm">
        <motion.span
          aria-hidden
          className="absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-transparent via-[#074EDC]/15 to-transparent"
          animate={{ x: ['-6rem', '30rem'] }}
          transition={{ duration: 3.2, repeat: Infinity, ease: 'linear' }}
        />
        <div className="relative text-white/90 font-medium">Governed AI work</div>
        <div className="relative text-white/60 text-sm">
          One accountable layer beneath every product
        </div>
      </div>
    </div>
  );
}
